import {
  listNotificationsFn,
  markNotificationReadFn,
} from "@/actions/community/handler";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Bell, CheckCheck } from "lucide-react";

export function NotificationCenter() {
  const notifications = useQuery({
    queryKey: ["notifications"],
    queryFn: () => listNotificationsFn(),
    refetchInterval: 60_000,
  });
  const markRead = useMutation({
    mutationFn: (notificationId?: string) =>
      markNotificationReadFn({ data: { notificationId } }),
    onSuccess: () => notifications.refetch(),
  });
  const items = notifications.data?.notifications || [];
  const unreadCount = items.filter((item) => !item.readAt).length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="relative"
          aria-label="Bildirimler"
        >
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="-right-0.5 -top-0.5 absolute flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] text-primary-foreground">
              {Math.min(unreadCount, 9)}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-[min(22rem,calc(100vw-2rem))] p-0"
      >
        <div className="flex items-center justify-between border-b p-3">
          <strong>Bildirimler</strong>
          {unreadCount > 0 && (
            <Button
              type="button"
              size="sm"
              variant="ghost"
              onClick={() => markRead.mutate(undefined)}
            >
              <CheckCheck className="mr-1 h-4 w-4" /> Tümünü okundu yap
            </Button>
          )}
        </div>
        <div className="max-h-[24rem] overflow-y-auto">
          {items.length ? (
            items.map((item) => (
              <Link
                key={item.notificationId}
                to={item.url}
                onClick={() => {
                  if (!item.readAt) markRead.mutate(item.notificationId);
                }}
                className={`block border-b p-3 transition-colors hover:bg-muted ${item.readAt ? "opacity-70" : "bg-primary/5"}`}
              >
                <p className="font-semibold text-sm">{item.title}</p>
                <p className="mt-1 line-clamp-2 text-muted-foreground text-xs">
                  {item.body}
                </p>
                <p className="mt-2 text-[10px] text-muted-foreground">
                  {new Date(item.createdAt).toLocaleString("tr-TR")}
                </p>
              </Link>
            ))
          ) : (
            <p className="p-6 text-center text-muted-foreground text-sm">
              Henüz bildiriminiz yok.
            </p>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
